export default __webpack_public_path__ + "static/media/icons8-kubernetes.b3d19d76.svg";